<template lang="pug">
  div(style="max-width: 1200px; margin: auto; padding: 40px;")
    yz-card.pa-8.d-flex.flex-column.align-center.justify-center(color="white" style="min-height: 300px;")
      yz-icon.mb-4(size="48px" color="yz-primary-500") $yzi-refresh-ccw-01
      .yz-heading-6.text-center.mb-2 {{ $t('panel.changing_to_single_view') }}
      .yz-regular-body-sm.text-neutral-500.text-center {{ $t('panel.please_wait_updating_view') }}

      // Loading indicator
      .mt-6
        v-progress-circular(indeterminate color="primary" size="32")
</template>

<script>
export default {}
</script>

<style scoped></style>
